import React, { FC, useEffect, useState } from 'react';
import { Keyword, Skill } from '../../../global';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSWR from 'swr';
import axiosHelper from '../../../helpers/axiosHelper';
import styles from './KeywordsEditor.module.scss';

interface KeywordsEditorProps {
  keywords: Keyword[];
  onChange: (keywords: Keyword[]) => void;
}

const KeywordsEditor: FC<KeywordsEditorProps> = ({ keywords, onChange }) => {
  const { data, error, isLoading } = useSWR('keywords', axiosHelper.newTagsFetcher);
  const [allTags, setAllTags] = React.useState<Keyword[]>([]);
  const [suggestionArray, setSuggestionArray] = React.useState<Keyword[]>([]);

  const [keywordString, setKeywordString] = useState('');

  useEffect(() => {
    if (data) {
      setAllTags(data);
    }
  }, [data]);

  const addKeyword = (keyword: Keyword) => {
    if (!keywords.find((item) => item.name === keyword.name)) {
      onChange([...keywords, keyword]);
    }
    setKeywordString('');
    setSuggestionArray([]);
  };
  const removeKeyword = (item: Keyword) => {
    onChange(keywords.filter((tag) => tag.name !== item.name));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('handleInputChange');
    const inputValue = e.target.value.replace(/[^\w\s]/gi, ''); // Remove punctuation symbols
    setKeywordString(inputValue);
    const filteredTags = allTags.filter((tag) => tag.name.toLowerCase().startsWith(inputValue.toLowerCase()));
    setSuggestionArray(filteredTags);
  };

  function handleBlur(event: React.FocusEvent<HTMLInputElement>): void {
    setTimeout(() => {
      setSuggestionArray([]);
      setKeywordString('');
    }, 300);
  }
  function handleFocus(event: React.FocusEvent<HTMLInputElement>): void {
    if (keywordString.length > 0) {
      const filteredTags = allTags.filter((tag) => tag.name.toLowerCase().startsWith(keywordString.toLowerCase()));
      setSuggestionArray(filteredTags);
    } else {
      setSuggestionArray(allTags);
    }
  }

  return (
    <>
      <div className="row mb-5">
        <div className="col-12 col-md-2 text fw-bold mb-3 ps-md-1 ps-2">
          <div className=" d-flex justify-content-between " style={{ zIndex: '10', position: 'relative' }}>
            <div className="col-11">
              Keywords <span className="color-dark_red me-1"> * </span>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-10">
          <input type="text" id="social" value={keywordString} placeholder="...start typing" onChange={handleInputChange} onFocus={handleFocus} onBlur={handleBlur} />
          {suggestionArray.length > 0 && (
            <div className={`${styles.suggestionWrapper}`}>
              {suggestionArray.map((item: Keyword, index: number) => (
                <div className={`text ${styles.suggestionRow}`} key={index} onClick={() => addKeyword(item)}>
                  {item.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {keywords.length > 0 && (
        <div className="row mb-5">
          <div className="col-12 col-md-2 mb-3 text"></div>

          <div className="col-12 col-md-10 ">
            {keywords.map(
              (item: Keyword, index: number) =>
                item && (
                  <button
                    type="button" // Prevent form submission by setting button type
                    className="btn-tag-editable mb-4 "
                    key={index}
                    onClick={() => removeKeyword(item)}
                  >
                    <span>
                      {item.name}
                      <FontAwesomeIcon icon={faXmark as IconProp} className="icon-tag" />{' '}
                    </span>
                  </button>
                )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default KeywordsEditor;
